export const staff = {
    panel: 'panel1',
    title: 'Administrativos',
    csvHeaders: 'codigo, nombre, sexo, idArea',
    headers: ['Código', 'Nombre', 'Sexo', 'Id Área o Id Departamento']
}

export const students = {
    panel: 'panel2',
    title: 'Estudiantes',
    csvHeaders: 'codigo, nombre, sexo, etnia, estatus, idCarrera, idCalendario, idSede',
    headers: ['Código', 'Nombre', 'Sexo', 'Etnia', 'Estatus', 'Id Carrera', 'Id Ciclo', 'Id Sede']
}

export const teachers = {
    panel: 'panel3',
    title: 'Profesores',
    csvHeaders: 'codigo, nombre, sexo, idDepartamento',
    headers: ['Código', 'Nombre', 'Sexo', 'Id Departamento']
}


export const records = {
    panel: 'panel4',
    title: 'Registro de Asistencia a Eventos',
    csvHeaders: 'idEvento, codigo',
    headers: ['Id Evento', 'Código']
}